/* Every date and time in the app is shown New York time: dates MM/DD/YYYY, times h:mm:ss AM/PM ET. */
const TZ = "America/New_York";
const parse = (v) => {
  if (!v) return null;
  if (v instanceof Date) return v;
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(`${s}T12:00:00-05:00`);   // a plain date is a calendar day, never shifted
  const iso = /[zZ]|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`;   // naive timestamps from the server are UTC
  const d = new Date(iso);
  return isNaN(d) ? null : d;
};
export const fmtDate = (v) => { const d = parse(v); return d ? d.toLocaleDateString("en-US", { timeZone: TZ, month: "2-digit", day: "2-digit", year: "numeric" }) : ""; };
export const fmtTime = (v, { seconds = true } = {}) => { const d = parse(v); return d ? d.toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit", second: seconds ? "2-digit" : undefined }) : ""; };
export const fmtDateTime = (v, opts) => { const d = parse(v); return d ? `${fmtDate(d)} ${fmtTime(d, opts)} ET` : ""; };
export const fmtMonth = (ym) => new Date(`${ym}-01T12:00:00-05:00`).toLocaleDateString("en-US", { timeZone: TZ, month: "long", year: "numeric" });
export const todayNY = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });   // YYYY-MM-DD in New York
